module.exports = __webpack_public_path__ + "img/inflable-sad.251fea9a.svg";